/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { invDependencies } from './dependenciesInv.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createDivide } from '../../factoriesAny.js';
export var divideDependencies = {
  divideScalarDependencies,
  equalScalarDependencies,
  invDependencies,
  matrixDependencies,
  multiplyDependencies,
  typedDependencies,
  createDivide
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesDivide.generated.js
// module id = DzC4
// module chunks = 3